import type { CommandBody } from '../CrossOriginMessage';

/**
 * Used to inform the execution of a method
 */
export class ExecutedMethodCommandBody implements CommandBody {
  outputMethod: any;
  methodIdentifier?: string;
  inputId?: string;
  inputClassId?: string;
}
